import { forwardRef, type LabelHTMLAttributes } from "react";
import { cn } from "@/lib/utils/cn";

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  required?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(function Label(
  { required, className, children, ...rest },
  ref,
) {
  return (
    <label
      ref={ref}
      className={cn(
        "inline-flex items-center gap-1 text-meta text-ink-2",
        "select-none",
        className,
      )}
      {...rest}
    >
      {children}
      {required ? (
        <span className="text-partner-strong" aria-label="必填">
          *
        </span>
      ) : null}
    </label>
  );
});
